<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <v-tabs
                app
				show-arrows
				:height="32"
				class="tabs-route"
				background-color="transparent"
				slider-color="primary">
                <v-tab exact-path ripple :to="{ path: '/subscriptions/clis/' + id + '/'}" key="clis">CLI Telefonico</v-tab>
            </v-tabs>

            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath"></router-view>
            </v-slide-y-reverse-transition>

        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'cli-tabs',
        props: {
            id: Number,
        },
        data() {
            return {
            }
        },

        created() {
            this.$store.commit('endProgress')
        }
    }
</script>